<template>
  <div class="industry">
    <el-divider content-position="left">话术分类管理</el-divider>
    <el-row style="text-align: right; margin-bottom: 0.4rem">
      <el-col :span="24">
        <el-button type="primary" size="mini" @click="handleAddOpen">添加</el-button>
      </el-col>
    </el-row>
    <el-table height="calc(100vh - 276px)" :data="pageData" size="medium" style="width: 100%" border>
      <el-table-column label="id" fixed>
        <template slot-scope="scope">
          {{ scope.row.cate_id }}
        </template>
      </el-table-column>
      <el-table-column label="话术名称">
        <template slot-scope="scope">
          {{ scope.row.cate_name }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-popconfirm
            @onConfirm="handleDelete(scope.$index, scope.row.cate_id)"
            confirmButtonText="确定"
            cancelButtonText="取消"
            icon="el-icon-info"
            iconColor="red"
            title="这是一段内容确定删除吗？"
          >
            <el-button size="mini" type="danger" slot="reference"> 删除 </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!--    页码-->
    <div class="page-footer">
    <el-pagination
    class="pagination-style"
      background
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <!--    添加-->
    <el-drawer
      title="添加"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">话术名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请输入话术名称"
              :size="inputSize"
              v-model="addData.industry_name"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAdd">添加</el-button>
        </div>
      </div>
    </el-drawer>
    <!--    编辑-->
    <el-drawer
      title="编辑"
      :visible.sync="saveDrawer"
      :direction="direction"
      :before-close="handleSaveDrawerClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">话术名称</el-col>
          <el-col :span="10">
            <el-input
              placeholder="请输入话术名称"
              :size="inputSize"
              v-model="saveData.industry_name"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "SalesTalkTypeManage",
  data() {
    return {
      option: [],
      inputSize: "small",
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      drawer: false,
      saveDrawer: false,
      direction: "rtl",
      addData: {
        industry_name: "",
      },
      saveData: {
        industry_name: "",
        industry_id: null,
        index: null,
      },
    };
  },
  computed: {
    pageData: {
      get: function () {
        return this.option.slice(
          this.pageOption.pageSize * (this.pageOption.currentPage - 1),
          this.pageOption.pageSize * this.pageOption.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getData() {
      this.$axios.get("/api/talkcate/list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.option = data.data;
          this.pageOption.total = this.option.length;
        }
      });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
    },
    handleSaveDrawerClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearSaveData();
          done();
        })
        .catch((_) => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleAddOpen() {
      this.drawer = true;
    },
    handleEdit(index, row) {
      this.saveData.industry_name = row.cate_name;
      this.saveData.industry_id = row.cate_id;
      this.saveData.index = index;
      this.saveDrawer = true;
    },
    handleDelete(index, id) {
      this.handleDeleteSub(index, id);
    },
    handleDeleteSub(index, id) {
      this.$axios.get("/api/talkcate/delete/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index;
          this.option.splice(idx, 1);
          this.pageOption.total = this.saveData.length;
          if (index === 0) this.prePage();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
    handleAdd() {
      if (!this.addData.industry_name) {
        this.$message.error("话术名称不能为空");
        return;
      }
      this.$axios
        .post("/api/talkcate/create", { val: [this.addData.industry_name] })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.option.unshift(data.data);
            this.pageOption.total = this.option.length;
            this.$message.success(data.msg);
            this.clearAddData();
            this.drawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    clearAddData() {
      this.addData.industry_name = "";
    },
    clearSaveData() {
      this.addData.industry_name = "";
    },
    handleSave() {
      if (!this.saveData.industry_name) {
        this.$message.error("话术名称不能为空");
        return;
      }
      this.$axios
        .post("/api/talkcate/update/" + this.saveData.industry_id, {
          val: [this.saveData.industry_name],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let index =
              this.pageOption.pageSize * (this.pageOption.currentPage - 1) +
              this.saveData.index;
            this.option[index].cate_name = this.saveData.industry_name;
            this.$message.success(data.msg);
            this.clearSaveData();
            this.saveDrawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.industry
  marginLeft()
.mt-10
  margin-top: .2rem
.tr
  text-align: right
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  overflow-y auto
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
.industry >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.addCon
  padding: .2rem
  text-align: right

.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 25px
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/SalesTalkTypeManage/SalesTalkTypeManage.vue